var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"dialog",attrs:{"width":"430px","type":"warning","mode":"centered","close-on":false,"show-cancel":true,"show-close":false,"show-confirm":true,"icon":"fas fa-exclamation","title":"La sesión actual expiró"},on:{"confirm":_vm.confirm}},[_vm._v("\n  ¿Desea renovar? (Si cancela la sesión finalizará)\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }